type ComponentImportMap = {
  imports: Record<string, string>
}

const COMPONENT_IMPORT_MAP_ID = "mvt-component-import-map"
const DEFAULT_IMPORTS = {
  vue: "https://esm.sh/vue@3.4.0"
}

const installImportMap = (imports: Record<string, string>) => {
  const existing = document.querySelector<HTMLScriptElement>(
    `#${COMPONENT_IMPORT_MAP_ID}`
  )
  if (existing) return false

  if (!Object.keys(imports).length) return false

  const script = document.createElement("script")

  script.id = COMPONENT_IMPORT_MAP_ID
  script.type = "importmap"
  script.textContent = JSON.stringify({ imports })
  document.head.appendChild(script)

  return true
}

const installComponentImportMap = (
  componentImportMap?: ComponentImportMap | null
) => {
  const componentImports = componentImportMap?.imports || {}
  if (!Object.keys(componentImports).length) return false

  return installImportMap({
    ...DEFAULT_IMPORTS,
    ...componentImports
  })
}

const installVueImportMap = () => installImportMap(DEFAULT_IMPORTS)

const installAppImportMap = (componentImportMap?: ComponentImportMap | null) =>
  installComponentImportMap(componentImportMap) || installVueImportMap()

export {
  COMPONENT_IMPORT_MAP_ID,
  installAppImportMap,
  installComponentImportMap,
  installVueImportMap
}
